// @flow
/* ***************************************************************************
* @author mfranco (mfranco@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import style from "./style.css"
import Input from "react-toolbox/lib/input"
import DatePicker from "../../../components/DatePicker"
import Dropdown from "react-toolbox/lib/dropdown/Dropdown"
import * as strings from "../../../strings"

export default class CreateInvoice2 extends Component {
  props: {
    newInvoice: any,
    onChange: () => any,
    areInputFieldsInvalid: [],
    contracts: []
  };

  render () {
    const { contracts, newInvoice, areInputFieldsInvalid, onChange } = this.props

    const err = strings.errorMessages.invalidValue

    return (
      <div className={style.mainContainer}>
        <div className={style.blueBar}>
        </div>
        <div className={style.firstDivisor}>
          <div className={style.firstLine}>
            <span><hr className={style.divider}/></span>
          </div>
          <div className={style.secondLine}>
            <span className={style.spanText}>{strings.invoices.createInvoice}</span>
          </div>
          <div className={style.thirdLine}>
            <span><hr className={style.divider}/></span>
          </div>
        </div>

        <div className={style.createContainer}>
          <Dropdown
            source={contracts}
            error={areInputFieldsInvalid[ 4 ] ? err : false }

            value={newInvoice.idContract}
            onChange={value => onChange( {
              idContract: value,
            } )}
            label="Número do Contracto" />

        </div>

        <div className={style.createContainer}>

          <div className={style.createContainerColumn}>
            <Input
              className={style.inputFix}
              value={newInvoice.documentNumber}
              error={areInputFieldsInvalid[ 0 ] ? err : false }
              onChange={value => onChange( {
                documentNumber: value,
              } )}
              maxLength={50}
              label="Número da factura"
              type="text" />
            <Input
              className={style.inputFix}
              error={areInputFieldsInvalid[ 1 ] ? err : false }
              value={newInvoice.value}
              onChange={value => onChange( {
                value: parseFloat( value ).toString(),
              } )}
              onFocus={event => onChange( {
                value: parseFloat( event.target.value ).toString(),
              } ) }
              min="0"
              label={strings.generalStrings.invoiceValue}
              maxLength={15}
              step="0.01"
              type="number" />
          </div>
          <div className={style.datePickerCss}>
            <DatePicker
              error={areInputFieldsInvalid[ 2 ] ? err : false }
              label="Data de Emissão"
              onChange={value => onChange( {
                date: new Date( value ),
              } )}
              value={ newInvoice.date }
            />
            <DatePicker
              error={areInputFieldsInvalid[ 3 ] ? err : false }
              label="Data de Vencimento"
              onChange={value => onChange( {
                expiryDate: new Date( value ),
              } )}
              value={ newInvoice.expiryDate }
            />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CreatePaymentAgreementComponents/CreateInvoice2/index.jsx